<template>
	<el-dialog
		:visible.sync="isShowNavTip"
		:title="null"
		:modal="false"
		width="248px"
		:show-close="false"
		append-to-body
		custom-class="nav-tip-dialog"
	>
		<div class="nav_tip">
			<!-- 用户信息头部 -->
			<div class="nav_user_header">
				<img v-if="userInfo.photoImg" class="nav_user_avatar" :src="'data:image/png;base64,' + userInfo.photoImg" />
				<div v-else class="nav_user_avatar nav_user_avatar--text">{{ (userInfo.chName || "用").slice(-2) }}</div>
				<div class="nav_user_meta">
					<div class="nav_user_name">{{ userInfo.chName || "用户" }}</div>
					<div class="nav_user_sub">{{ userInfo.pos || userInfo.dept || userInfo.user || "" }}</div>
				</div>
			</div>
			<div class="nav_tc top_01">
				<div class="nav_tc_d" @click="userInfoClick">
					<i class="el-icon-user nav_tc_i"></i>
					<span class="nav_tc_s">个人信息</span>
					<i class="el-icon-arrow-right nav_tc_arrow"></i>
				</div>
				<div class="nav_tc_d" @click="clickChangePwd">
					<i class="el-icon-lock nav_tc_i"></i>
					<span class="nav_tc_s">修改密码</span>
					<i class="el-icon-arrow-right nav_tc_arrow"></i>
				</div>
				<div class="nav_tc_d nav_tc_logout" @click="clickLoginOut">
					<i class="el-icon-switch-button nav_tc_i"></i>
					<span class="nav_tc_s">退出登录</span>
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import { leaveOnlineSession } from "@/utils/onlinePresence";
export default {
	name: "NavTip",
	props: {},
	data() {
		return {
			isShowNavTip: false,
			userInfo: {}
		};
	},
	components: {},
	mounted() {},
	methods: {
		showTip(userInfo) {
			this.userInfo = userInfo;
			// 给 wrapper 打class：兜底方案（给不支持 :has() 的浏览器）。
			// wrapper 由 el-dialog 渲染在本组件之外且 append-to-body，
			// 不能靠 this.$el 拿到，改用下一帧查询。
			this.$nextTick(() => {
				const w = document.querySelector(".nav-tip-dialog");
				if (w && w.parentElement && w.parentElement.classList) {
					w.parentElement.classList.add("lcsj-navtip-wrapper");
				}
			});
			this.isShowNavTip = true;
		},

		// 修改密码
		clickChangePwd() {
			// 先关掉本下拉：它用 modal=false（无遮罩），
			// 不关的话会与随后打开的「修改密码」弹窗叠在一起，且下拉在上层挡住操作
			this.isShowNavTip = false;
			this.$emit("click-change-pwd");
		},

		// 个人信息
		userInfoClick() {
			this.isShowNavTip = false;
			this.$emit("user-info-click");
		},

		// 退出登录
		clickLoginOut() {
			this.$confirm("退出登录, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				setTimeout(async () => {
					// this.disconnectToHub();
					if (this.$tabs) {
						this.$tabs.reset();
					}
					await leaveOnlineSession();
					localStorage.clear();
					sessionStorage.removeItem("accessToken");
					this.$router.replace({
						path: "/login"
					});
					this.$message({
						type: "success",
						message: "已退出登录!"
					});
					this.isShowNavTip = false;
				}, 300);
			});
		}
	}
};
</script>

<style scoped>
.nav_tip {
	width: 100%;
	background: var(--app-surface);
	color: var(--app-text);
	padding: 8px;
	border-radius: 14px;
	box-sizing: border-box;
}

/* 用户信息头部 */
.nav_user_header {
	display: flex;
	align-items: center;
	padding: 10px 12px 14px;
	margin-bottom: 6px;
	border-bottom: 1px solid var(--app-border-light);
}

.nav_user_avatar {
	width: 46px;
	height: 46px;
	border-radius: 50%;
	object-fit: cover;
	margin-right: 12px;
	border: 1px solid var(--app-border);
	flex-shrink: 0;
}

.nav_user_avatar--text {
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, var(--app-primary) 0%, var(--app-primary-hover) 100%);
	color: var(--app-surface);
	font-size: 20px;
	font-weight: 600;
}

.nav_user_meta {
	min-width: 0;
	flex: 1;
}

.nav_user_name {
	font-size: 15px;
	font-weight: 600;
	color: var(--app-text);
	line-height: 1.3;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.nav_user_sub {
	font-size: 12px;
	color: var(--app-text-muted);
	margin-top: 3px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.nav_tc {
	width: 100%;
	background: var(--app-surface);
	border-radius: 8px;
	overflow: hidden;
}

.nav_tc_d {
	width: 100%;
	height: 44px;
	padding: 0 12px;
	border-radius: 8px;
	display: flex;
	align-items: center;
	cursor: pointer;
	box-sizing: border-box;
	transition: background-color 0.2s ease, color 0.2s ease;
}

.nav_tc_d:hover {
	background: var(--app-primary-soft);
}

.nav_tc_i {
	font-size: 17px;
	width: 20px;
	margin-right: 10px;
	color: var(--app-primary);
	text-align: center;
	transition: color 0.2s ease;
}

.nav_tc_s {
	flex: 1;
	font-size: 14px;
	color: var(--app-text-secondary);
}

.nav_tc_arrow {
	font-size: 12px;
	color: var(--app-border-strong);
	transition: transform 0.2s ease, color 0.2s ease;
}

.nav_tc_d:hover .nav_tc_s {
	color: var(--app-primary);
}

.nav_tc_d:hover .nav_tc_arrow {
	color: var(--app-primary);
	transform: translateX(2px);
}

/* 退出登录：分隔线 + 危险色 */
.nav_tc_logout {
	margin-top: 6px;
	padding-top: 0;
	border-top: 1px solid var(--app-border-light);
	border-radius: 0 0 8px 8px;
}

.nav_tc_logout .nav_tc_i,
.nav_tc_logout .nav_tc_s {
	color: var(--app-danger);
}

.nav_tc_logout:hover {
	background: var(--app-danger-soft);
}

.nav_tc_logout:hover .nav_tc_s {
	color: var(--app-danger);
}

.top_01 {
	margin-top: 0;
}

/*面板内部样式见文件末尾的非 scoped 块（append-to-body 后 scoped 匹配不到） */

/* 弹层定位到右上角、贴合内容、去除默认外观 */
.nav-tip-dialog {
	position: absolute;
	right: 14px;
	top: 54px;
	margin: 0 !important;
	border-radius: 14px;
	border: 1px solid var(--app-surface-sunken);
	box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16);
	overflow: hidden;
}

.nav-tip-dialog .el-dialog__header {
	display: none;
}

.nav-tip-dialog .el-dialog__body {
	padding: 0;
	background-color: var(--app-surface);
}
</style>

<!--
  第二段：非scoped。
  el-dialog 的 wrapper 与 .nav-tip-dialog 都渲染在本组件模板之外（append-to-body），
  scoped 编译后带data-v 属性会匹配不上它们，所以定位样式必须放在非 scoped 块里。
-->
<style>
/*
 * nav-tip-dialog 的层级处理（**必须非 scoped**）
 * ---------------------------------------------------------------------------
 * ① 为什么模板上加了 append-to-body：
 *    lcsjDialog 默认 append-to-body=true（弹窗挂到 body）；而本组件早期没加，
 *    弹窗留在 TitleBar 内部 ⇒ 两者不在同一 DOM 层，
 *    nav-tip 的 wrapper（.el-dialog__wrapper 是全屏 fixed）会盖住 body 层的新弹窗，
 *    表现为「点了个人信息 / 修改密码没反应」。
 *
 * ② 为什么必须压缩 wrapper：
 *    :modal="false" 只是不显示遮罩，wrapper 依然是 position:fixed 的全屏层，
 *    依旧会吞掉页面上所有点击。必须缩到面板大小 + 去掉自身滚动与背景。
 *
 * ③ 为什么用 :has()：
 *    el-dialog 渲染在组件模板之外，scoped 编译出的 data-v 属性匹配不到，
 *    故这些定位样式只能放在非 scoped 块里。
 *    :has() 是主方案；.lcsj-navtip-wrapper 是给不支持 :has() 的浏览器兜底
 *    （由 script 在 showTip 时打上）。
 */
.el-dialog__wrapper:has(.nav-tip-dialog),
.el-dialog__wrapper.lcsj-navtip-wrapper {
	position: fixed;
	top: 54px;      /* = 顶栏高度，面板挂在顶栏下方 */
	right: 14px;
	bottom: auto;
	left: auto;
	width: 248px;   /* 与 el-dialog 的 width 一致 */
	height: auto;
	overflow: visible;
	background: transparent;
}

/* 面板本体：由 wrapper 定位后，这里只需去掉居中偏移 */
.nav-tip-dialog {
	position: absolute;
	top: 0;
	left: 0;
	right: auto;
	bottom: auto;
	margin: 0 !important;
	background: var(--app-surface);
}

.nav-tip-dialog .el-dialog__header {
	display: none;
}

.nav-tip-dialog .el-dialog__body {
	padding: 0;
	background-color: var(--app-surface);
}
</style>
